"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A mediator that picks the first actor that resolves its test.
 */


var MediatorRace =
/*#__PURE__*/
function (_core_1$Mediator) {
  _inherits(MediatorRace, _core_1$Mediator);

  function MediatorRace(args) {
    _classCallCheck(this, MediatorRace);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediatorRace).call(this, args));
  }

  _createClass(MediatorRace, [{
    key: "mediateWith",
    value: function mediateWith(action, testResults) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var errors = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var testResult = _step.value;
            testResult.reply.then(function () {
              resolve(testResult.actor);
            }).catch(function (error) {
              // Reject if all replies were rejected
              errors.push(error);

              if (errors.length === testResults.length) {
                reject(new Error(_this.name + ' mediated over all rejecting actors:\n' + errors.map(function (e) {
                  return e.toString();
                }).join('\n')));
              }
            });
          };

          for (var _iterator = testResults[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }]);

  return MediatorRace;
}(core_1.Mediator);

exports.MediatorRace = MediatorRace;